import {helpers} from 'commerce-sdk-isomorphic'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
const BASE_URI = 'https://{shortCode}.alternativeBaseUri.com/custom/{apiName}/{apiVersion}'
class CustomApi {
    // Calling API
    base(method, token, apiName, endpointPath, parameters, proxy, body, rawResponse = false) {
        let options = {
            method: method,
            parameters: parameters,
            headers: this.getHeader(token),
            customApiPathParameters: this.getCustomApiPathParameters(apiName, endpointPath)
        }
        if (body) {
            options.body = JSON.stringify(body)
        }
        return helpers.callCustomEndpoint({
            options: options,
            clientConfig: this.getClientConfig(apiName, proxy),
            rawResponse: rawResponse
        })
    }

    // Get Request
    get(token, apiName, endpointPath, parameters, proxy, rawResponse) {
        return this.base('get', token, apiName, endpointPath, parameters, proxy, null, rawResponse)
    }

    // POST Request
    post(token, apiName, endpointPath, parameters, proxy, body) {
        return this.base('post', token, apiName, endpointPath, parameters, proxy, body)
    }

    // Get Header
    getHeader(token) {
        return {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    }

    // Get Custom API Path Parameters
    getCustomApiPathParameters(apiName, endpointPath) {
        return {
            apiName: apiName,
            endpointPath: endpointPath,
            apiVersion: 'v2'
        }
    }

    // Get Client Config
    getClientConfig(apiName, proxy) {
        const {
            app: {commerceAPI}
        } = getConfig()
        return {
            parameters: {
                ...commerceAPI.parameters,
                apiName: apiName
            },
            proxy: proxy,
            baseUri: BASE_URI
        }
    }
}

export default CustomApi
